import React from 'react'
import * as Sentry from '@sentry/react'
import {Navigate} from 'react-router-dom'
import {useAtom} from 'jotai'
import {
    accessToken,
    claveUsuario,
    estacionID,
    nombrePuntoVenta,
    puntoVentaID,
    usuarioID,
    TranspaisIDToken
} from '../../utilities/atoms'
import { isValidTranspaisJwtShape } from '../../utilities/token'
//import {isauth}  from 'auth'

const ProtectedRoute = ({component}) => {
    const [cveUsuario,] = useAtom(claveUsuario)
    const [usuarioId,] = useAtom(usuarioID)
    const [puntoVentaId,] = useAtom(puntoVentaID)
    const [estacionId,] = useAtom(estacionID)
    const [token,] = useAtom(accessToken)
    const [nombPuntoVenta,] = useAtom(nombrePuntoVenta)
    const [transpaisIDToken,] = useAtom(TranspaisIDToken)

    const checkAuth = () => {
        const t = transpaisIDToken.trim()
        return t !== '' && isValidTranspaisJwtShape(t)
    }

    const authed = checkAuth()

    if (!authed) {
        Sentry.setUser(null)
    }

    return authed ? component : <Navigate to={'/login'}/>
}

export default ProtectedRoute